import { Component, OnInit, PLATFORM_ID, ChangeDetectionStrategy, input, inject, DestroyRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-site-information',
    templateUrl: './site-information.component.html',
    styleUrls: ['./site-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class SiteInformationComponent implements OnInit {
  readonly data = input<any>(undefined);
  readonly contentView = input<boolean>(undefined);

  routeData: any;
  siteInfo: boolean = false;
  home: boolean = false;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() { }

  ngOnInit(): void {
    if (this.router.url === '/') {
      this.home = true;
    }

    this.router.events.pipe(
      filter((data) => data instanceof RoutesRecognized),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((data: any) => {
      if (data instanceof RoutesRecognized) {
        this.routeData = data.state.root.firstChild.url;

        if (!this.routeData.length) {
          this.home = true;
        } else {
          this.home = false;
        }
      }
    });
  }

  displaySiteInfo(): void {
    this.siteInfo = !this.siteInfo;

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 50);
    }
  }

  positionFooter(): string {
    const contentView = this.contentView();
    if (this.home && !contentView) {
      return 'absolute'
    } else if (this.home && contentView) {
      return 'relative lg:absolute'
    } else if (this.siteInfo && contentView && !this.home) {
      return 'relative'
    } else if (!contentView && !this.home) {
      return 'absolute lg:absolute';
    } else {
      return 'relative lg:absolute';
    }
  }
}
